import { IconName } from '@core/user-interface-legacy';

export const pageIdToIconMapping: Record<string, [inactive: IconName, active: IconName]> = {
  team_members: ['nav-candidates-outline', 'nav-candidates-filled'],
  company: ['nav-company', 'nav-company'],
  groups: ['tellent-nav-groups-inactive', 'tellent-nav-groups-active'],
  departments: ['tellent-nav-departments-inactive', 'tellent-nav-departments-active'],
  billing: ['nav-billing-outline', 'nav-billing-filled'],
  home: ['tellent-nav-dashboard-inactive', 'tellent-nav-dashboard-active'],
  dashboard: ['tellent-nav-dashboard-inactive', 'tellent-nav-dashboard-active'],
  profile: ['tellent-nav-me-inactive', 'tellent-nav-me-active'],
  calendar: ['tellent-nav-calendar-month-inactive', 'tellent-nav-calendar-month-active'],
  reviews: ['tellent-nav-performance-inactive', 'tellent-nav-performance-active'],
  campaigns: ['tellent-nav-performance-inactive', 'tellent-nav-performance-active'],
  skills: ['tellent-nav-development-inactive', 'tellent-nav-development-active'],
  trainings: ['tellent-nav-development-inactive', 'tellent-nav-development-active'],
  goals: ['tellent-nav-goals-inactive', 'tellent-nav-goals-active'],
  people: ['tellent-nav-people-inactive', 'tellent-nav-people-active'],
  reports: ['tellent-nav-reports-inactive', 'tellent-nav-reports-active'],
  payroll: ['tellent-nav-payroll-inactive', 'tellent-nav-payroll-active'],
  'people:*': ['tellent-nav-people-inactive', 'tellent-nav-people-active'],
  'attendance:*': ['tellent-nav-attendance-inactive', 'tellent-nav-attendance-active'],
  'journeys:*': ['tellent-nav-journeys-inactive', 'tellent-nav-journeys-active'],
  'company:*': ['tellent-nav-company-inactive', 'tellent-nav-company-active'],
  'time_off:*': ['tellent-nav-time-off-inactive', 'tellent-nav-time-off-active'],
  'payroll:*': ['tellent-nav-payroll-inactive', 'tellent-nav-payroll-active'],
  'expenses:*': ['tellent-nav-expenses-inactive', 'tellent-nav-expenses-active'],
  'talent_reviews:*': ['tellent-nav-talent-reviews-inactive', 'tellent-nav-talent-reviews-active'],
  my_team: ['tellent-nav-my-team-inactive', 'tellent-nav-my-team-active'],
  feedback: ['tellent-nav-feedback-inactive', 'tellent-nav-feedback-active'],
  engagement: ['tellent-nav-engagement-inactive', 'tellent-nav-engagement-active'],
  users: ['tellent-nav-people-inactive', 'tellent-nav-people-active'],
  overview: ['tellent-nav-overview-inactive', 'tellent-nav-overview-active'],
  candidates: ['nav-candidates-outline', 'nav-candidates-filled'],
  jobs: ['nav-jobs-outline', 'nav-jobs-filled'],
  mailbox: ['nav-mailbox-outline', 'nav-mailbox-filled'],
  analytics: ['nav-reports-outline', 'nav-reports-filled'],
  talent_pools: ['nav-talent-pools-outline', 'nav-talent-pools-filled'],
  acquisition: ['nav-aquisitions-outline', 'nav-aquisitions-filled'],
  marketplace: ['nav-marketplace-outline', 'nav-marketplace-filled'],
  intelligence: ['ai', 'ai'],
  requisitions: ['nav-requisitions-outline', 'nav-requisitions-outline'],
  'ask:*': ['local-activity', 'local-activity'],

  // One Settings Icons
  // some items of settings are not there yet (from contract), some will be deleted

  // Organization
  'admin-home': ['tellent-nav-organisation-inactive', 'tellent-nav-organisation-active'],
  'settings:departments': ['tellent-nav-departments-inactive', 'tellent-nav-departments-active'],

  // Recruitee
  'settings:profile': ['tellent-nav-my-account-inactive', 'tellent-nav-my-account-active'],
  'settings:company_settings': ['tellent-nav-general-inactive', 'tellent-nav-general-active'],
  'settings:requisition_approvals': [
    'tellent-nav-workflows-inactive',
    'tellent-nav-workflows-active',
  ],
  'settings:job_templates': ['tellent-nav-templates-inactive', 'tellent-nav-templates-active'],
  'settings:jobs_widget': ['tellent-nav-integration-inactive', 'tellent-nav-integration-active'],

  // HR Grow
  'settings:notifications': ['nav-notifications-outline', 'nav-notifications-filled'],
  'settings:company': ['tellent-nav-features-inactive', 'tellent-nav-features-active'],
  'settings:custom_fields': [
    'tellent-nav-custom-fields-inactive',
    'tellent-nav-custom-fields-active',
  ],
  'settings:groups': ['tellent-nav-groups-inactive', 'tellent-nav-groups-active'],
  'settings:trainings': ['tellent-nav-integration-inactive', 'tellent-nav-integration-active'],

  // HR Manage
  'settings:access_levels': ['tellent-nav-permissions-inactive', 'tellent-nav-permissions-active'],
  'settings:teams': ['tellent-nav-general-inactive', 'tellent-nav-general-active'],
  'settings:company_custom_modules': [
    'tellent-nav-company-data-inactive',
    'tellent-nav-company-data-active',
  ],
  'settings:employee_custom_modules': [
    'tellent-nav-employee-data-inactive',
    'tellent-nav-employee-data-active',
  ],
  'settings:attendance_projects': [
    'tellent-nav-attendance-inactive',
    'tellent-nav-attendance-active',
  ],
  'settings:whistleblowing': [
    'tellent-nav-whistleblowing-inactive',
    'tellent-nav-whistleblowing-active',
  ],
  'settings:journey_types': ['tellent-nav-journeys-inactive', 'tellent-nav-journeys-active'],
  'settings:attendance_work_schedules': [
    'tellent-nav-attendance-inactive',
    'tellent-nav-attendance-active',
  ],
  'settings:time_off_policies': ['tellent-nav-time-off-inactive', 'tellent-nav-time-off-active'],
  'settings:payroll_types': ['tellent-nav-payroll-inactive', 'tellent-nav-payroll-active'],
  'settings:expense_categories': ['tellent-nav-expenses-inactive', 'tellent-nav-expenses-active'],
  'settings:integrations_apps': [
    'tellent-nav-integration-inactive',
    'tellent-nav-integration-active',
  ],
};
